module.exports = __webpack_public_path__ + "img/vecozo.c0734565.png";